/**
 * @generated SignedSource<<40f127ef79a23e3e3fbedec444608add>>
 * @relayHash 235a53a7f1a59b43affd5c88ad73b5d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1fb4b1607c4c295da3622acdf87e179a8287b1142a0ec64937bf7f1dbff3301e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1fb4b1607c4c295da3622acdf87e179a8287b1142a0ec64937bf7f1dbff3301e",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
